module.exports = __webpack_public_path__ + "media/fonts/fa-solid-900-0253ced610e4c3ac5038118428629806.woff";